import React from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import '../../ChannelFacebookMessenger.scss';

import ChannelFacebookMessengerLoginButton from './ChannelFacebookMessengerLoginButton';
import { setAuthState } from '../../../../../store/actions/facebook-messenger';

/**
 * Component for ask the user for login with his Facebook account
 *
 * @param {*} props
 * @returns
 */
const ChannelFacebookMessengerLogin = (props) => {
  const { i18n, user } = props;

  return (
    <div className="facebook-login-elements">
      <p className="facebook-login-text">
        Para que seus clientes interajam com seu bot pelo Facebook Messenger é
        necessário que a sua empresa possua uma página, logue-se a baixo se sua
        página já está criada, se sua empresa não tiver uma página
        <a href="https://www.facebook.com/help/104002523024878">crie agora.</a>
      </p>
      <br />
      <ChannelFacebookMessengerLoginButton disabled={true} title="Entrar com o Facebook" user={user}/>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    bot: state.bots.bot,
    facebookAuth: state.facebookAuth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ setAuthState }, dispatch);
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(ChannelFacebookMessengerLogin))
);
